export default {
    sign: (param, callback, options) => {
        appfreeExec("vidrandom", "", param, (signed_msg, vid_msg) => {
            callback({
                status: 1,
                data: signed_msg,
                vidRandom: vid_msg
            }, param)
        })
    }
}